import { render, staticRenderFns } from "./ForgotUsername.vue?vue&type=template&id=6c23efa6&scoped=true"
import script from "./ForgotUsername.vue?vue&type=script&lang=js"
export * from "./ForgotUsername.vue?vue&type=script&lang=js"
import style0 from "./ForgotUsername.vue?vue&type=style&index=0&id=6c23efa6&prod&scoped=true&lang=css"
import style1 from "./ForgotUsername.vue?vue&type=style&index=1&id=6c23efa6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c23efa6",
  null
  
)

export default component.exports